import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { BillingPlanModelsView } from "src/components/views/erp/sales/billingPlan/model/BillingPlanModelsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/billingPlanModels")({
	staticData: { title: i18n.t("billing_plan_models"), legacyViewKey: "billingPlanModelsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <BillingPlanModelsView />;
}
